import { z } from 'zod';
export const fileSchema = z.object({
    id: z.string().min(1),
    name: z.string().min(1).nullish(),
}, { invalid_type_error: 'A file is required' });
//# sourceMappingURL=input-schemas.js.map